import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

import { Loadable } from '®shared/data';

@entity({ type: 'bookstore_availabilities' })
export class BookstoreAvailability extends JsonapiEntity<BookstoreAvailability> {
  @attribute() availability: string;
  @attribute() currency: string;
  @attribute() price?: string;
  @attribute() price_lowest_used?: string;
  @attribute() price_lowest_new?: string;
  @attribute() detail_page_url: string;
  @attribute() jacket_image_url: string;
  @attribute() stock_statement: string;
  @attribute() isResolved: boolean;

  get anyPrice(): string {
    const [firstItem] = [
      this.price,
      this.price_lowest_new,
      this.price_lowest_used,
    ].filter(
      string =>
        typeof string === 'string' &&
        string.trim() &&
        Number.isFinite(Number(string)),
    );

    return firstItem;
  }
}

export interface LoadableBookstoreAvailability
  extends Loadable<BookstoreAvailability> {}
